import styled from "styled-components";
import { useQuery} from "react-query";
import {blueprintCategory} from "../../../../../utils/const/query-key";
import apiService from "../../../../../api/apiService";
import ReadMore from "../../../demoPointEnv/createEnv/components/steps/thirdStep/ReadMore";
import {useState} from "react";


const TitleHeaderWrapper = styled.div`
    display:flex;
    place-content: space-between;
    font-size: small;
`;

const TitleWrapper = styled.div`
    display:flex;
    font: var(--unnamed-font-style-normal) normal normal 14px/18px DIN Pro;
    text-align: left;
    font: normal normal normal 14px/18px DIN Pro;
    letter-spacing: 0.02px;
    color:  var(--color-text-body);
    opacity: 1;
`;

const ListStyle = styled.li`
  width: auto;
  background: var(--color-workspace-bg-page-area);
  padding:10px;
  cursor: pointer;
  list-style: none;
  color:  var(--color-form-font-description);

  &:hover {
    .header_blueprint {
      color: var(--color-brand-pink-primary);
    }
    .icon {
      color: var(--color-brand-pink-primary);
     }
    .icon_image {
      width: 20px;
    }
  }

  .icon_image {
    width: 17px;
    margin: 0px 10px 12px 0px;
  }

  .icon_bottom{
  display: flex;
  height: 15px;
  justify-content:end;
  font: normal normal normal 12px/18px DIN Pro;
  letter-spacing: 0px;
  color: var(--color-table-filter);
  text-transform: capitalize;
  opacity: 1;
  
  }

  .separator {
    color: var(--color-separator-icon);
  }
`;



const BlueprintTableCell = ({bp}) => {
    const [expanded, setExpanded] = useState(true);
    const {data: blueprintCategoryData} = useQuery(blueprintCategory, () =>
            apiService.getBlueprintCategoryData(),
        {staleTime: Infinity}
    );

    const matchBlueprintIcon = (category) => {
        return (blueprintCategoryData?.filter(bp => bp !== '' && bp?.name === category)
        );
    }
    let bpCategoryDataObject = matchBlueprintIcon(bp?.category);



    return (
        <ListStyle className={"select_blueprint"}>
            <TitleHeaderWrapper>
                <TitleWrapper>
                    {bpCategoryDataObject && <img className={"icon_image"} src={bpCategoryDataObject[0]?.icon} alt={bp?.category}/>}
                    <div className={"header_blueprint"}>{bp?.name}</div>
                </TitleWrapper>
            </TitleHeaderWrapper>
            <ReadMore expanded={expanded} setExpanded={setExpanded}>
                {bp?.description}
            </ReadMore>
        </ListStyle>
    )
}
export default BlueprintTableCell;